export default function moveProgressSection() {
  const isPresent = document.querySelector("[data-progress]");
  if (!isPresent) {
    return;
  }

  const progressDiv = document.querySelector("[data-progress]");
  const progressSmDiv = document.querySelector("[data-progress-sm]");
  const originalParent = progressDiv.parentElement; // Save original parent for repositioning

  const handleResize = () => {
    if (window.innerWidth <= 1100) {
      // Move `data-progress` into `data-progress-sm`
      if (
        progressDiv &&
        progressSmDiv &&
        !progressSmDiv.contains(progressDiv)
      ) {
        progressSmDiv.appendChild(progressDiv);
      }
    } else {
      // Move `data-progress` back to its original position
      if (
        progressDiv &&
        originalParent &&
        !originalParent.contains(progressDiv)
      ) {
        originalParent.appendChild(progressDiv);
      }
    }
  };

  // Trigger resize handler on page load and on window resize
  handleResize();
  window.addEventListener("resize", handleResize);
}
